import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  loading: false,
  data: [],
  solutionPlansData: [],
  billingResponseData: {}
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
